import { Coordinate } from '../../../models/coordinate/coordinate';
import { RestoreSearchStateParams } from './restore-search-state-params';
import { URLSearchQuery } from './url-search-query';
import { ViewMode } from './view-mode';

export function makeRestoreSearchStateParams(
  params: URLSearchQuery,
): RestoreSearchStateParams {
  const res: RestoreSearchStateParams = {
    currentPosition: null,
    viewMode: null,
    seats: null,
    startsFromTime: null,
    searchAreaGroupKey: null,
    searchAreaKey: null,
  };

  if (params.lat && params.lng) {
    res.currentPosition = new Coordinate(
      parseFloat(params.lat),
      parseFloat(params.lng),
    );
  }

  if (params.seats) {
    res.seats = parseInt(params.seats, 10);
  }

  if (params.view) {
    res.viewMode = params.view === 'list' ? ViewMode.List : ViewMode.Map;
  }

  res.searchAreaKey = params.area;
  res.searchAreaGroupKey = params.areaGroup;
  res.startsFromTime = params.startsFromTime;

  return res;
}
